export const USER_ACTION = {
  CONSENT_DOWNLOAD: "consent_download",
  PROFILE_VIEW: "profile_view",
};
